module.exports = __webpack_public_path__ + "img/546w.ef9fb66.jpg";